import { rootApi } from '../rootApi';

export const fullServiceKmApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getFullServiceKm: builder.query({
            query: (params) => ({
                url: 'api/fullservicekm/getfullservicekm',
                method: 'GET',
                params: {
                    PageNumber: params.pageNumber,
                    PageSize: params.pageSize,
                    FullServiceId: params.fullServiceId,
                    Status: params.Status
                }
            }),
            providesTags: ['FullServiceKm']
        }),

        getFullServiceKmById: builder.query({
            query: (id) => ({
                url: `api/fullservicekm/getfullservicekmbyid?id=${id}`,
                method: 'GET'
            }),
            providesTags: ['FullServiceKm']
        }),

        createFullServiceKm: builder.mutation({
            query: (data) => ({
                url: 'api/fullservicekm/create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['FullServiceKm']
        }),

        updateFullServiceKm: builder.mutation({
            query: (data) => ({
                url: 'api/fullservicekm/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['FullServiceKm']
        }),

        deleteFullServiceKm: builder.mutation({
            query: (id) => ({
                url: 'api/fullservicekm/delete',
                method: 'POST',
                body: { id }
            }),
            invalidatesTags: ['FullServiceKm']
        }),
        changeFullServiceKmStatus: builder.mutation({
            query: ({ id, newStatus, note }) => ({
                url: '/api/fullservicekm/changestatus',
                method: 'POST',
                body: {
                    id,
                    newStatus,
                    note
                }
            }),
            invalidatesTags: ['FullServiceKm']
        })
    })
});

export const { useGetFullServiceKmQuery, useGetFullServiceKmByIdQuery, useCreateFullServiceKmMutation, useUpdateFullServiceKmMutation, useDeleteFullServiceKmMutation, useChangeFullServiceKmStatusMutation } = fullServiceKmApi;
